import {createContext} from 'react'
import type {AgentMode} from '@github-ui/copilot-shared-ui/utils/agent-mode'

export type OnUpdateMode = (mode: AgentMode) => void

/** The persisted agent-mode selection driving the composer's mode picker. */
export const ModeSelectionContext = createContext<AgentMode | undefined>(undefined)

/** Records a new mode choice for the established composer to apply to its session. */
export const ModeUpdateContext = createContext<OnUpdateMode | null>(null)

export interface ModePickerState {
  selectedMode: AgentMode | undefined
  onUpdateMode: OnUpdateMode
}
